<template>
  <CustomPage :title="$route.params.brand" color="black" bgcolor="white">
    <div slot="content" style="height: 100%">
      <div
        class="lightshadow rounded-md m-3 p-3"
        @click="$router.push({ name: 'BrandPlace', params: { partId: 111 } })"
      >
        <div class="flex items-center">
          <div class="w-12 h-12 flex-shrink-0 mr-2">
            <img
              class="w-full h-full rounded"
              src="https://img01.yzcdn.cn/vant/cat.jpeg"
              alt=""
            />
          </div>
          <div class="flex-grow">
            <div class="font-semibold">耐克</div>
            <div>
              <span
                class="text-xxs text-red border-red1px rounded p-1 mr-1"
                style="white-space: nowrap; line-height: 1.125rem"
                >共110款</span
              >
            </div>
          </div>
          <div><Icon name="arrow" /></div>
        </div>
        <div class="flex justify-around mt-2 text-center">
          <div>
            <div class="text-xxs">总访问人数</div>
            <div class="text-xs font-semibold">2</div>
          </div>
          <div>
            <div class="text-xxs">成交订单</div>
            <div class="text-xs font-semibold">1</div>
          </div>
        </div>
      </div>
      <div v-for="i in 3" :key="i" class="lightshadow rounded-md m-3 p-3">
        <div class="flex">
          <div class="w-8 h-8 flex-shrink-0 mr-2">
            <img
              class="w-full h-full rounded-full"
              src="https://img01.yzcdn.cn/vant/cat.jpeg"
              alt=""
            />
          </div>
          <div class="text-xs flex-grow">
            <div>ERNEST</div>
            <div>浏览<span class="text-red">2</span>件</div>
          </div>
          <div class="text-xs text-gray flex-shrink-0">2021-01-03 10:30:30</div>
        </div>
        <div class="flex">
          <div
            v-for="j in 3"
            :key="j"
            class="w-12 h-12 flex-shrink-0 mr-1 mt-1"
            @click="$router.push({ name: 'GoodsDetail', params: { id: 111 } })"
          >
            <img
              class="w-full h-full rounded"
              src="https://img01.yzcdn.cn/vant/cat.jpeg"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from "@/components/custom-page.vue";
import { Icon } from "vant";
export default {
  components: { CustomPage, Icon },
  created() {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.active {
  background-color: #e82035;
  color: white;
}
::v-deep .van-tab--active {
  font-weight: 600;
  color: #e82035;
}
</style>